import React from "react";
const FormBuilderFormInterfaceParagraph = ({ item, t }) => {
  if (!item) return null;
  return /* @__PURE__ */ React.createElement("p", { className: item.class }, t(item == null ? void 0 : item.nodeValue));
};
FormBuilderFormInterfaceParagraph.displayName = "FormBuilderFormInterfaceParagraph";
export default FormBuilderFormInterfaceParagraph;
